export default __webpack_public_path__ + "static/media/apple.22a735e2.svg";